(() => {
  if (customElements.get('neopace-hero-subtitle')) return;
  customElements.define('neopace-hero-subtitle', class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('.neopace-deposit-hero');
      this.heading = this.querySelector('h1');
      this.subtitle = this.querySelector('p');
      if (!this.root || !this.subtitle) return;
      this.observer = new ResizeObserver(() => this.measure());
      if (this.heading) this.observer.observe(this.heading);
      this.observer.observe(this.subtitle);
      this.measure();
    }
    measure() {
      this.root.style.setProperty('--neopace-heading-height', `${this.heading?.getBoundingClientRect().height || 0}px`);
      // Scale the desktop positioning contribution, not the approved subtitle font size.
      this.root.style.setProperty('--neopace-subtitle-space-desktop', `calc(${this.subtitle.getBoundingClientRect().height + 12} * min(0.052083333333vw, 1px))`);
      this.root.style.setProperty('--neopace-subtitle-space', `${this.subtitle.getBoundingClientRect().height + (innerWidth < 750 ? 8 : 12)}px`);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.root?.style.removeProperty('--neopace-heading-height');
      this.root?.style.removeProperty('--neopace-subtitle-space');
      this.root?.style.removeProperty('--neopace-subtitle-space-desktop');
    }
  });
})();
